'use client';

import { useEffect } from 'react';

/**
 * Tryb modalny (osadzenie strony kursu w iframe przez ?modal=true).
 * Dodaje klasę do <body>, by globalny layout ukrył navbar/footer/ticker.
 * Wydzielone do klienta — sama treść kursu renderuje się serwerowo (SSR).
 */
export default function ModalModeHandler() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('modal') === 'true') {
      document.body.classList.add('modal-iframe-mode');
      return () => {
        document.body.classList.remove('modal-iframe-mode');
      };
    }
  }, []);

  return null;
}
